import React, { useContext, useState } from "react";
import { Button } from "semantic-ui-react";
import { NotificationContext } from "../../../../../notifications";
import { useTranslation } from "react-i18next";
import { LoadingScreen } from "mapsted-components";
import { useMutation } from "react-query";
import { MUTATIONS } from "../../../../../../_api/queries";
import { ModalLayoutRevised } from "../../../../../common/ModaLayoutRevision/ModalLayoutRevised";

export const AddClaimModal = ({
    claimList,
    companyId,
    claimId,
    claimName,
    handleHideModel,
    setClaimId,
    refetchData,
    onSaveClaimCallback,
}) => {
    const trans = useTranslation().t;
    const notifications = useContext(NotificationContext);
    const [claimNameInput, setClaimNameInput] = useState(claimName || "");
    const [error, setError] = useState("");

    // add claim
    const {
        mutateAsync: mutateAddClaim,
        reset: resetAddClaim,
        isLoading: isLoadingAdd,
    } = useMutation(MUTATIONS.sso.ADD_CLAIM(refetchData));
    // update claim
    const {
        mutateAsync: mutateUpdateClaim,
        reset: resetUpdateClaim,
        isLoading: isLoadingUpdate,
    } = useMutation(MUTATIONS.sso.UPDATE_CLAIM(refetchData));

    const handleModalClose = () => {
        resetAddClaim();
        resetUpdateClaim();
        handleHideModel();
    };

    const checkClaimAlreadyExists = (claimName) => {
        const claim = claimList?.find((item) => item.claimName === claimName);

        if (
            claim &&
            claimName === claim?.claimName
            // (!claimId || claimId !== claim?.id)
        ) {
            return true;
        }

        return false;
    };

    const handleSaveClaim = async () => {
        try {
            if (!claimNameInput) {
                setError("Missing Claim Name.");
                return;
            }

            if (checkClaimAlreadyExists(claimNameInput)) {
                setError("Claim name already exists.");
                return;
            }

            const data = {
                companyId,
                claimName: claimNameInput,
            };

            if (claimId) {
                await mutateUpdateClaim({ claimId, data });
                onSaveClaimCallback(claimNameInput);
                resetUpdateClaim();
            } else {
                const responseData = await mutateAddClaim(data);
                resetAddClaim();

                // handle newly selected claim
                if (responseData?.data && responseData.data?.id) {
                    setClaimId(responseData.data.id);
                } else {
                    throw new Error(`${responseData || "Unknown error"}`);
                }
            }

            handleModalClose();
        } catch (err) {
            console.log("err ", err);
            notifications.addNotification(
                "danger",
                "Save Claim Failed",
                "Try again later"
            );

            handleModalClose();
        }
    };

    const title = claimId
        ? trans("Sso.AddEditClaimModal.Edit_Claim")
        : trans("Sso.AddEditClaimModal.Add_Claim");
    const saveBtnText = claimId
        ? trans("Sso.AddEditClaimModal.Update")
        : trans("Sso.AddEditClaimModal.Save");
    const alreadyExists = checkClaimAlreadyExists(claimNameInput);
    const disableSaveButton = !claimNameInput || alreadyExists || error;
    return (
        <ModalLayoutRevised
            open={true}
            onClose={() => handleModalClose()}
            heading={title}
            hideClose={true}
            size="mini"
            // regularModal={true}
            className={"AddClaimModal"}
            actions={
                <>
                    <Button
                        color="orange"
                        type="button"
                        floated="right"
                        content={saveBtnText}
                        className="submit-btn"
                        onClick={handleSaveClaim}
                        disabled={disableSaveButton}
                    />
                    <Button
                        type="button"
                        floated="left"
                        content={"Cancel"}
                        className="cancel-btn"
                        onClick={() => {
                            handleModalClose();
                        }}
                    />
                </>
            }
        >
            {(isLoadingAdd || isLoadingUpdate) && <LoadingScreen />}

            <div className="claimModal-container">
                <label className="text-label">
                    {trans("Sso.AddEditClaimModal.Claim_Name")}
                </label>
                <input
                    required={true}
                    type="text"
                    maxLength={100}
                    className={`input-field ${error ? "input-error" : ""}`}
                    placeholder={claimId ? claimNameInput : "Enter SSO Claim name"}
                    value={claimNameInput}
                    onChange={(e) => {
                        setError("");
                        setClaimNameInput(e.target.value);
                    }}
                />

                {error && <span className="error-message">{error}</span>}
            </div>
        </ModalLayoutRevised>
    );
};
